import { render } from "./SkillsAssessment.vue?vue&type=template&id=5b1a2f3e"
import script from "./SkillsAssessment.vue?vue&type=script&lang=js"
export * from "./SkillsAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__